$( document ).ready(function() {
        resize();
});

window.addEventListener("resize", resize);

function resize() {
    if ($("#elodiebonjour").length) {
        $("#elodiebonjour").css({"width": "auto", "left": "auto", "position": "relative"});
        $("#elodiebonjour").addClass("visible");
    }
}



